module.exports = __webpack_public_path__ + "img/icon-20-help.f42bfa5e.svg";